import { createSlice } from '@reduxjs/toolkit';

export const initialState = {};

const widgetInfoSlice = createSlice({
	name: 'widgetInfo',
	initialState,
	reducers: {
		setWidgetInfo(state, action) {
			Object.assign(state, action.payload);
		}
	}
});

export const { setWidgetInfo } = widgetInfoSlice.actions;

export default widgetInfoSlice.reducer;
